import React from "react";

const PortalFooter: React.FC = () => (
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
      padding: "20px 16px",
      color: "var(--theme-text-soft)",
      borderTop: "1px solid var(--theme-border)",
      background: "var(--theme-surface-raised)",
    }}
  >
    <style>{`
      @keyframes smartdoc-link-pulse {
        0% {
          filter: drop-shadow(0 0 0 rgba(0, 102, 87, 0.85));
        }
        50% {
          filter: drop-shadow(0 0 6px rgba(0, 102, 87, 0.75));
        }
        100% {
          filter: drop-shadow(0 0 14px rgba(0, 102, 87, 0));
        }
      }
      .smartdoc-footer-link {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        color: #006657;
        text-decoration: none;
        font-weight: 700;
        font-size: 1.1rem;
        animation: smartdoc-link-pulse 1.6s ease-out 0.6s 1;
      }
      .smartdoc-footer-logo {
        height: 44px;
        background: #006657;
        padding: 6px;
        border-radius: 6px;
      }
    `}</style>
    <a
      href="https://www.smartdoc.com.py"
      target="_blank"
      rel="noopener noreferrer"
      className="smartdoc-footer-link"
    >
      <img
        src="/smart-logo-no-text-white.webp"
        alt="Smartdoc"
        className="smartdoc-footer-logo"
      />
      Smartdoc
    </a>
    <span style={{ fontSize: "0.9rem", color: "var(--theme-muted)" }}>
      - Sistema de Facturación Electrónica
    </span>
  </div>
);

export default PortalFooter;
